import { render, staticRenderFns } from "./Datagrim.vue?vue&type=template&id=523f9e25"
import script from "./Datagrim.vue?vue&type=script&lang=js"
export * from "./Datagrim.vue?vue&type=script&lang=js"
import style0 from "./Datagrim.vue?vue&type=style&index=0&id=523f9e25&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports